module.exports = __webpack_public_path__ + "static/media/freshteam-logo.80d5a257.svg";